<template>
	<!-- 角色管理 -->
	<div class="systemRole">
		<!-- 添加 -->
		<div class="systemRolePC pulbic_system_oparetionBlock">
			<div class="systemRolePC-btn public_operatBtn" style="margin-left: 0px;">
				<el-button class="public_saleWater_xinzeng" type="primary" icon="el-icon-circle-plus-outline" @click="addDialogShow" v-shiroHiden="solelist" id="新增">新增</el-button>
			</div>
			<div class="systemRolePC-table">
				<!-- 标题 -->
				<div class="systemRolePC-table-li public-table-bg">
					<div class="systemRolePC-table-li-name">角色名称</div>
					<div class="systemRolePC-table-li-describe">角色描述</div>
					<!-- <div class="systemRolePC-table-li-type">角色类型</div> -->
					<div class="systemRolePC-table-li-isman">是否管理员</div>
					<div class="systemRolePC-table-li-operation">操作</div>
				</div>
				<!-- 内容 -->
				<div class="systemRolePC-table-li public-table-bg public-hover" v-for="(item,index) in rolelist" :key="index">
					<div class="systemRolePC-table-li-name">{{item.PERTB003CA00}}</div>
					<div class="systemRolePC-table-li-describe">{{item.PERTB003CA01}}</div>
					<!-- <div class="systemRolePC-table-li-type">{{item.PERTB003CB00text}}</div> -->
					<div class="systemRolePC-table-li-isman">{{item.PERTB003CB01text}}</div>
					<div class="systemRolePC-table-li-operation">
						<el-button class="public_icon_xiugai public_icon_width public_icon_margin" type="primary" size="small" @click="upDialogShow(item)" v-shiroHiden="solelist" id="修改">修改</el-button>
						<el-button class="public_icon_jinyong public_icon_width public_icon_margin" type="danger" size="small" @click="deleteClick(item)" v-if="item.PERTB003CB01!=1"  v-shiroHiden="solelist" id="删除">删除</el-button>
						<!--  -->
						<el-button class="public_icon_juese public_icon_width" type="warning"  size="small" @click="querMenuData(item)" v-shiroHiden="solelist" id="角色授权">角色授权</el-button>
					</div>
				</div>
			</div>
			<div class="systemRolePC-no-text" v-if="rolelist.length==0">暂无数据</div>
			<div class="systemRolePC-pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage2"
				 :page-sizes="[10, 20, 30, 40]" :page-size="pageNum" layout="total,sizes, prev, pager, next" :total="count">
				</el-pagination>
			</div>
		</div>
		<!-- 添加弹框 -->
		<div class="public-dialog">
			<el-dialog title="新增角色" :visible.sync="systemRoleAddDia" width="33%" :closeOnClickModal="false">
				<div class="systemRolePC-add-role">
					<div class="systemRolePC-add-role-table">
						<div class="systemRolePC-add-role-table-li">
							<div class="systemRolePC-add-role-table-li-name">角色名称:</div>
							<div class="systemRolePC-add-role-table-li-describe">
								<input type="text" maxlength="10" v-model="addroleObj.PERTB003CA00" @blur="isroleNameBlur">
							</div>
							<div class="systemRolePC-add-role-table-li-mand">*必填*</div>
						</div>
						<div class="systemRolePC-add-role-table-li">
							<div class="systemRolePC-add-role-table-li-name">角色描述:</div>
							<div class="systemRolePC-add-role-table-li-describe">
								<input type="text" v-model="addroleObj.PERTB003CA01" maxlength="100">
							</div>
							<div class="systemRolePC-add-role-table-li-mand"></div>
						</div>
					</div>
					<div class="systemRolePC-add-role-btn">
						<el-button type="primary" @click="addRole">保存</el-button>
						<el-button type="warning" @click='systemRoleAddDia=false'>取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 修改弹框 -->
		<div class="public-dialog">
			<el-dialog title="编辑角色" :visible.sync="systemRoleAddup" width="33%" :closeOnClickModal="false">
				<div class="systemRolePC-add-role">
					<div class="systemRolePC-add-role-table">
						<div class="systemRolePC-add-role-table-li">
							<div class="systemRolePC-add-role-table-li-name">角色名称:</div>
							<div class="systemRolePC-add-role-table-li-describe">
								<input type="text" v-model="uproleObj.PERTB003CA00" maxlength="10" @blur="isUproleNameBlur">
							</div>
							<div class="systemRolePC-add-role-table-li-mand">*必填*</div>
						</div>
						<div class="systemRolePC-add-role-table-li">
							<div class="systemRolePC-add-role-table-li-name">角色描述:</div>
							<div class="systemRolePC-add-role-table-li-describe">
								<input type="text" v-model="uproleObj.PERTB003CA01" maxlength="100">
							</div>
							<div class="systemRolePC-add-role-table-li-mand"></div>
						</div>
					</div>
					<div class="systemRolePC-add-role-btn">
						<el-button type="primary" @click="upRole">保存</el-button>
						<el-button type="warning" @click='systemRoleAddup=false'>取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 角色授权 -->
		<div class="public-dialog systemRolePC-dialog">
			<el-dialog title="角色授权" :visible.sync="roleAuthorization" width="20%" :closeOnClickModal="false">
				<div class="systemRolePC-authorization">
					<el-tree :data="treeData" show-checkbox node-key="id" ref="tree"
					:default-checked-keys="treeKey" :props="defaultProps" >
					</el-tree>
					<div class="systemRolePC-authorization-btn">
						<el-button type="primary" @click="treeChange">保存</el-button>
						<el-button type="warning" @click="roleAuthorization=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				systemRoleAddDia: false,
				systemRoleAddup: false,
				// 角色授权
				roleAuthorization: false,
				treeData:[],
				treeKey:[],
				defaultProps: {
					children: 'childMenus',
					label: 'PERTB001CA00'
				},
				checkList: [],
				currentPage2: 1,
				pageSize:1,
				pageNum:10,
				count:1,
				addroleObj:{
					PERTB003CA00:'',//角色名称
					PERTB003CA01:''//角色名描述
				},
				uproleObj:{
					PERTB003ID:'',
					PERTB003CA00:'',
					PERTB003CA01:'',
					PERTB003CA00old:''
				},
				isnameCode:false,
				isUPnameCode:true,
				rolelist:[],
				roleId:'',
				userobj:'',
				solelist:[],
				// 历史缓存
				currentUrl:this.$route.path,
				historyInfo:''
			}
		},
		created(){
			this.solelist=this.$baseAPI.querSoleList(this.$store.state.solelist,this.$route.path)
			// 赋值，缓存销毁
			this.historyInfo=JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if(this.historyInfo!=null&&this.historyInfo!=''){
				this.init()
			}
		},
		mounted() {
			this.userobj=this.$store.state.uobj
			this.querPostroleLsit()
		},
		// 存储数据
		beforeDestroy() {
			var obj={
				currentPage2:this.currentPage2,//当前页数
				pageSize:this.pageSize,//页码
				pageNum:this.pageNum//每页条数
			}
			sessionStorage.setItem(this.currentUrl,JSON.stringify(obj))
		},
		methods: {
			//初始化数据
			init(){
				this.currentPage2=this.historyInfo.currentPage2
				this.pageSize=this.historyInfo.pageSize
				this.pageNum=this.historyInfo.pageNum
			},
			deleteClick(item) {// 删除
				this.$confirm(`此操作将角色删除：${item.PERTB003CA00}, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var url=`/per/pertb003/delete/${item.PERTB003ID}`
					this.axios.get(url).then(res=>{
						// console.log(res)
						if(res.data.code==200){
							this.$message.success('删除成功');
							this.pageSize=1
							this.querPostroleLsit()
						}else{
							this.$message.error(res.data.message);
						}
					})
				}).catch(() => {

				});
			},
			treeChange() {//获取到全部已选的id
				let res = this.$refs.tree.getCheckedNodes()
				let chechArr = []
				res.forEach((item) => {
					chechArr.push(item.id)
				})
				let halfArr=this.$refs.tree.getHalfCheckedKeys()
				this.setRoleMenu([...chechArr,...halfArr])
			},
			handleSizeChange(val) {//每页多少条
				this.pageSize=1
				this.pageNum=val
				this.querPostroleLsit()
			},
			handleCurrentChange(val) {//当前页
				this.pageSize=val
				this.querPostroleLsit()
			},
			querPostroleLsit(){//角色列表查询
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				})
				var url='/per/pertb003/selectPageList'
				var data={
					page:this.pageSize,
					limit:this.pageNum,
					PERTB005CB00:this.userobj.pertb005.pertb005cb00,
					PERTB003CD01:this.userobj.pertb005.pertb005cd01
				}
				this.axios.post(url,data).then(res=>{
					// console.log(res)
					setTimeout(()=>{
						loading.close()
					},300)
					if(res.data.code==200){
						var resdata=res.data.data||[]
						for(var i=0;i<resdata.length;i++){
							if(resdata[i].PERTB003CB01==0){
								resdata[i].PERTB003CB01text='否'
							}else if(resdata[i].PERTB003CB01==1){
								resdata[i].PERTB003CB01text='是'
							}
						}
						this.rolelist=resdata
						this.count=res.data.count
					}else{
						this.rolelist=[]
						this.count=0
						this.$message.error(res.data.message)
					}
				}).catch(errrse=>{
					loading.close()
				})
			},
			addDialogShow(){
				this.systemRoleAddDia=true
				this.addroleObj={
					PERTB003CA00:'',
					PERTB003CA01:''
				}
			},
			addRole(){//添加
				if(this.addroleObj.PERTB003CA00.trim().length==0) return this.$message.error('请输入角色名称')
				if(!this.isnameCode) return this.$message.error('角色名称已存在！')
				var url='/per/pertb003/insert'
				var data={
					PERTB003CA00:this.addroleObj.PERTB003CA00,
					PERTB003CA01:this.addroleObj.PERTB003CA01,
					PERTB005CB00:this.userobj.pertb005.pertb005cb00,
					PERTB003CD01:this.userobj.pertb005.pertb005cd01
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url,data).then(res=>{
					// console.log(res)
					if(res.data.code==200){
						this.pageSize=1
						this.querPostroleLsit()
						this.systemRoleAddDia=false
					}else{
						this.$message.error(res.data.message)
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			isroleNameBlur(){//校验用户名
				if(this.addroleObj.PERTB003CA00.trim().length==0) return
				var url='/per/pertb003/checkPertb003ca00'
				var data={
					PERTB003CA00:this.addroleObj.PERTB003CA00,
					PERTB005CB00:this.userobj.pertb005.pertb005cb00,
					PERTB003CD01:this.userobj.pertb005.pertb005cd01
				}
				this.axios.post(url,data).then(res=>{
					// console.log(res)
					if(res.data.code==500){
						this.isnameCode=false
						this.$message.error('角色名称已存在！')
					}else if(res.data.code==200){
						this.isnameCode=true
					}
				})
			},
			isUproleNameBlur(){//修改校验用户名
				if(this.uproleObj.PERTB003CA00.trim().length==0) return this.$message.error('请输入角色名称')
				if(this.uproleObj.PERTB003CA00==this.uproleObj.PERTB003CA00old) return
				var url='/per/pertb003/checkPertb003ca00'
				var data={
					PERTB003CA00:this.uproleObj.PERTB003CA00,
					PERTB005CB00:this.userobj.pertb005.pertb005cb00,
					PERTB003CD01:this.userobj.pertb005.pertb005cd01
				}
				this.axios.post(url,data).then(res=>{
					// console.log(res)
					if(res.data.code==500){
						this.isUPnameCode=false
						this.$message.error('角色名称已存在！')
					}else if(res.data.code==200){
						this.isUPnameCode=true
					}
				})
			},
			querMenuData(item){//查询角色菜单
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.treeData=[]
				this.treeKe=[]
				this.roleAuthorization=true
				this.roleId=item.PERTB003ID
				var url='/per/pertb003/getMenuData'
				var data={
					PERTB003ID:item.PERTB003ID,//角色id
					PERTB005CB00:item.PERTB003CB00,
				}
				this.axios.post(url,data).then(res=>{
					// console.log(res)
					setTimeout(()=>{
						loading.close()
					},300)
					if(res.data.code==200){
						var keyid=[]
						var str=JSON.stringify(res.data.data)
						this.treeData=JSON.parse(str.replace(/PERTB001ID/g,'id'));
						this.treeData.forEach(resitem=>{
							if(resitem.childMenus.length>0){//一级导航
								var childMenus1=resitem.childMenus
								childMenus1.forEach(resitem1=>{//二级导航
									if(resitem1.childMenus.length>0){
										var childMenus2=resitem1.childMenus
										childMenus2.forEach(resitem2=>{//三级导航
											if(resitem2.childMenus.length>0){
												var childMenus3=resitem2.childMenus
												childMenus3.forEach(resitem3=>{//按钮
													if(resitem3.childMenus.length>0){
														var childMenus4=resitem3.childMenus
														childMenus4.forEach(resitem4=>{//列
															if(resitem4.checked){
																keyid.push(resitem4.id)
															}
														})
													}else{
														if(resitem3.checked){
															keyid.push(resitem3.id)
														}
													}
												})
											}else{
												if(resitem2.checked){
													keyid.push(resitem2.id)
												}
											}
										})
									}else{
										if(resitem1.checked){
											keyid.push(resitem1.id)
										}
									}
								})
							}else{
								if(resitem.checked){
									keyid.push(resitem.id)
								}
							}
						})
						this.treeKey=keyid
					}else{
					}
				}).catch(errrse=>{
					loading.close()
				})
			},
			upDialogShow(item){//显示修改弹框
				this.systemRoleAddup=true
				this.uproleObj.PERTB003CA00=item.PERTB003CA00
				this.uproleObj.PERTB003CA00old=item.PERTB003CA00
				this.uproleObj.PERTB003CA01=item.PERTB003CA01
				this.uproleObj.PERTB003ID=item.PERTB003ID
			},
			upRole(){//保存修改
				if(this.uproleObj.PERTB003CA00.trim().length==0) return this.$message.error('请输入角色名称')
				if(!this.isUPnameCode) return this.$message.error('角色名称已存在！')
				var url='/per/pertb003/update'
				var data={
					PERTB003ID:this.uproleObj.PERTB003ID,
					PERTB003CA00:this.uproleObj.PERTB003CA00,
					PERTB003CA01:this.uproleObj.PERTB003CA01
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url,data).then(res=>{
					// console.log(res)
					if(res.data.code==200){
						this.systemRoleAddup=false
						this.$message.success('修改成功');
						this.querPostroleLsit()
					}else{
						this.$message.error(res.data.message);
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			setRoleMenu(list){//角色授权
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url='/per/pertb003/setRoleMenu'
				var data={
					PERTB003ID:this.roleId,
					menuIds:list,
				}
				// console.log(data)
				this.axios.post(url,data).then(res=>{
					// console.log(res)
					if(res.data.code==200){
						this.roleAuthorization=false
						this.$message.success('授权成功')
					}else{
						this.$message.error(res.data.message)
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			}
		}
	}
	
</script>

<style scoped>
	.systemRolePC {
		padding: 30px 40px 0 20px;
		box-sizing: border-box;
	}
	.systemRolePC-no-text{
		font-size: 18px;
		text-align: center;
		line-height: 80px;
		border-bottom: 1px solid #CDCDCD;
	}
	.systemRolePC-table {
		margin-top: 50px;
	}

	.systemRolePC-table-li {
		display: flex;
		text-align: center;
		border-bottom: 1px solid #CDCDCD;
		height: 40px;
		line-height:40px;
		font-size: 14px;
		color: #333;
	}
	.systemRolePC-table-li:first-child{
		font-weight: bold;
		font-size: 16px;
		height: 48px;
		line-height: 48px;
	}
	.systemRolePC-table-li-name,
	.systemRolePC-table-li-type {
		flex: 1;
	}
	.systemRolePC-table-li-describe {
		flex: 1.2;
	}
	.systemRolePC-table-li-isman{
		flex: .5;
	}
	.systemRolePC-table-li-operation {
		flex: 1.2;
	}

	.systemRolePC-table-li {
		/* border-top: none; */
	}

	.systemRolePC-table-li:first-child {
		font-weight: bold;
		font-size: 16px;
		/* border-top: 1px solid #CDCDCD; */
	}

	.systemRolePC-pagesize {
		padding: 20px 0;
		text-align: right;
	}

	.systemRolePC-add-role {
		padding-left: 20px;
	}

	.systemRolePC-add-role-table-li {
		display: flex;
		font-size: 14px;
		color: #333;
	}

	.systemRolePC-add-role-table-li>div {
		border: 1px solid #CDCDCD;
	}

	.systemRolePC-add-role-table-li>div:last-child {
		border: none;
	}

	.systemRolePC-add-role-table-li>div:first-child {
		border-right: none;
		background: rgba(240,252,255,1);
	}

	.systemRolePC-add-role-table-li:first-child>div {
		border-bottom: none;
	}

	.systemRolePC-add-role-table-li-name,
	.systemRolePC-add-role-table-li-describe {
		flex: 1;
		text-align: center;
		height: 41px;
		line-height: 41px;

	}

	.systemRolePC-add-role-table-li-describe {
		border-left: none;
	}

	.systemRolePC-add-role-table-li-mand {
		flex: .3;
		line-height: 40px;
		padding-left: 5px;
		color: #FF4D35;
	}

	.systemRolePC-add-role-table-li-describe input {
		height: 36px;
		line-height: 36px;
		width: 95%;
		border: none;
		text-align: center;
		font-size: 14px;
		vertical-align: top;
	}

	.systemRolePC-add-role-table-li-describe input:focus {
		border: none;
		outline: none;
		color: #333;
	}

	.systemRolePC-add-role-btn {
		text-align: center;
		padding: 40px 0 20px 0;
	}
	.systemRolePC-authorization{
		padding: 40px 0 40px 40px;
		height: 400px;
		overflow-y: auto;
	}
	.systemRolePC-authorization-btn{
		margin-top: 50px;
		text-align: center;
	}
</style>
